/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {EmGroup} from './em-group';
import {Group} from './group';
import {Image} from './image';
import {LocationInstance} from "./location-instance";
import {Point} from "./point";
import {UserData} from './user-data';
import {ZoneInstance} from "./zone-instance";
import {ObjectInstance} from "./object-instance";

export class User {
  id: number;
  login: string;
  password: string;
  lastName: string;
  firstName: string;
  email: string;
  phoneNumber: string;
  cellNumber: string;
  image: Image;
  icon: Image;
  lastSignon: Date;
  isActive: boolean;
  creationDate: Date;
  passwordLastChangedDate: Date;
  uuid: string;
  data: UserData[];
  groups: Group[];
  entityGroups: EmGroup[];
  location: LocationInstance;
  zone: ZoneInstance;
  position: Point;
  person: ObjectInstance;
  twoFactorEnabled: boolean;
  locked: boolean;
}

export class UserUI {
  user: User;
  mSelected: boolean;
}
